module.exports = __webpack_public_path__ + "img/tree.fe08d4be.svg";